export async function asyncForEach<T>(
  iteratee: T[],
  callbackFn: (value: T, index: number, array: T[]) => Promise<unknown>
): Promise<void> {
  const promises = iteratee.map(async (...callbackFnParams) => {
    await callbackFn(...callbackFnParams);
  });

  await Promise.all(promises);
}

export async function asyncMap<T, CbReturn>(
  iteratee: T[],
  callbackFn: (value: T, index: number, array: T[]) => Promise<CbReturn>
): Promise<CbReturn[]> {
  const promises = iteratee.map(async (...callbackFnParams) =>
    callbackFn(...callbackFnParams)
  );

  return Promise.all(promises);
}

export function removeItemFromArray<T>(
  array: T[] | undefined,
  item: T
): T[] | undefined {
  if (!array) {
    return array;
  }

  const index = array.indexOf(item);
  const newArray = [...array];

  if (index !== -1) {
    newArray.splice(index, 1);
  }

  return newArray;
}

export function sortElementsByAscending<T = number[] | Date[] | string[]>(
  array: T[],
  dataType: 'number' | 'date' | 'string' = 'number'
): T[] {
  switch (dataType) {
    case 'number':
    case 'date':
      return [...array].sort((a: any, b: any) => a - b);
    case 'string':
      return [...array].sort();
  }
}

export function sortElementByDescending<T = number[] | Date[] | string[]>(
  array: T[],
  dataType: 'number' | 'date' | 'string' = 'number'
): T[] {
  switch (dataType) {
    case 'number':
    case 'date':
      return [...array].sort((a: any, b: any) => b - a);
    case 'string':
      return [...array].sort().reverse();
  }
}

export function sortObjectsByDescending<T>(
  objects: T[],
  propertyName: keyof T
): T[] {
  return [...objects].sort(
    (a, b) =>
      (b?.[propertyName] as unknown as number) -
      (a?.[propertyName] as unknown as number)
  );
}

export function sortObjectsByAscending<T>(
  objects: T[],
  propertyName: keyof T
): T[] {
  return [...objects].sort(
    (a, b) =>
      (a?.[propertyName] as unknown as number) -
      (b?.[propertyName] as unknown as number)
  );
}
